import { ApplicationConfig, ErrorHandler, provideBrowserGlobalErrorListeners, isDevMode, APP_INITIALIZER, LOCALE_ID } from '@angular/core';
import { provideRouter, withViewTransitions } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideServiceWorker } from '@angular/service-worker';
import { provideAuth, LogLevel, OidcSecurityService } from 'angular-auth-oidc-client';
import { MAT_ICON_DEFAULT_OPTIONS } from '@angular/material/icon';
import { provideNgxMask } from 'ngx-mask';
import { catchError, of } from 'rxjs';
import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';

import { routes } from './app.routes';
import { GlobalErrorHandler } from './core/handlers/global-error.handler';
import { authInterceptor } from './core/auth/interceptors/auth.interceptor';
import { auditInterceptor } from './core/interceptors/audit.interceptor';
import { mockInterceptor } from './core/interceptors/mock.interceptor';
import { environment } from '@env/environment';
import { AuthService } from './core/auth/services/auth.service';

registerLocaleData(localePt, 'pt-BR');

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withViewTransitions()),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([authInterceptor, auditInterceptor, mockInterceptor])),
    provideAuth(
      {
        config: {
          authority: `${environment.keycloak.issuer}/realms/${environment.keycloak.realm}`,
          redirectUrl: `${window.location.origin}/auth/callback`,
          postLogoutRedirectUri: window.location.origin,
          clientId: environment.keycloak.clientId,
          scope: 'openid profile email',
          responseType: 'code',
          silentRenew: true,
          silentRenewUrl: `${window.location.origin}/silent-renew.html`,
          renewTimeBeforeTokenExpiresInSeconds: 60,
          secureRoutes: [environment.apiUrl],
          logLevel: environment.production ? LogLevel.Error : LogLevel.Debug,
        },
      }
    ),
    {
      provide: APP_INITIALIZER,
      useFactory: (oidcSecurityService: OidcSecurityService) => () => {
        return oidcSecurityService.checkAuthMultiple().pipe(
          catchError((error) => {
            console.warn('[AUTH] Falha ao inicializar o OIDC (Keycloak offline/inacessível):', error);
            // Sinaliza para o AuthService que o Keycloak está offline
            AuthService.keycloakOffline = true;
            // Retorna um observable que completa com sucesso para não quebrar o bootstrap do Angular
            return of([]);
          })
        );
      },
      multi: true,
      deps: [OidcSecurityService],
    },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    { provide: MAT_ICON_DEFAULT_OPTIONS, useValue: { fontSet: 'material-symbols-rounded' } },
    provideNgxMask(),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ],
};

